<form
	#descriptionForm="ngForm"
	(ngSubmit)="save(descriptionForm)"
	class="form flex flex-col items-center p-5"
>
	<app-input
		class="w-full"
		label="Title"
		[placeholder]="originalTitle"
		[(ngModel)]="description"
		[required]="true"
		[submitted]="submitted"
		name="description"
	></app-input>
	<div class="mt-2 text-sm text-grey">
		Original title: <span class="font-bold">{{ originalTitle }}</span>
	</div>

	<div class="flex justify-between w-full mt-10">
		<app-button btn="tertiary" (click)="close()" size="small"
			>Cancel</app-button
		>
		<app-button type="submit" size="small">Save</app-button>
	</div>
</form>
